import { render, staticRenderFns } from "./ModuleTransferHistory.vue?vue&type=template&id=197c6cbc&scoped=true"
import script from "./ModuleTransferHistory.vue?vue&type=script&lang=js"
export * from "./ModuleTransferHistory.vue?vue&type=script&lang=js"
import style0 from "./ModuleTransferHistory.vue?vue&type=style&index=0&id=197c6cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197c6cbc",
  null
  
)

export default component.exports